import Vue from 'vue';

const CustomConsts = {
  install(Vue, options) {
    const CONSTS = {
      STATUS_MAPPING: {
        forSellAndRent: "售租",
        forSell: "售",
        forRent: "租",
        forSellWithRent: "連約售"
      },
      COMPASS_MAPPING: {
        unknown: "未知",
        south: "南",
        west: "西",
        east: "東",
        north: "北",
        northEast: "東北",
        northWest: "西北",
        southEast: "東南",
        southWest: "西南"
      },
      FAV_PREFIX: 'topagent_fav_'
    }
    Vue.prototype.$getConst = (key) => {
      return CONSTS[key]
    }
  }
};

export default CustomConsts;